/* ======================================================================
   BUNDLE BAR LOGIC v4 – totals + strikethrough
   ====================================================================== */
(function () {
    document.addEventListener('DOMContentLoaded', () => {
        const bar = document.getElementById('bundleBar');
        if (!bar) return;

        /* offer parameters */
        const MAX_ITEMS = parseInt(bar.dataset.bundleSize, 10) || 3;
        const OFFER_PRICE_STRING = bar.dataset.bundlePrice || '999';
        const OFFER_PRICE_INT = parseInt(OFFER_PRICE_STRING.replace(/[,₹\s]/g, '')) * 100; // to paise

        /* dom refs */
        const progressEl = bar.querySelector('[data-bundle-progress]');
        const totalEl = bar.querySelector('[data-bundle-total]');
        const nextBtn = bar.querySelector('[data-bundle-next]');
        const slots = bar.querySelectorAll('.bundle-slot');
        const plusIcons = bar.querySelectorAll('.bundle-plus');

        /* state */
        const bundle = [];          // [{id,title,img,price}]
        const BTN_ADD = '<span class="btn-fill" data-fill></span><span class="btn-text">Add&nbsp;to&nbsp;box</span>';
        const BTN_DONE = '<span class="btn-text">Added</span>';

        /* helpers */
        const formatMoney = p => `₹${(p / 100).toFixed(2)}`;
        const cardBtnFor = id => document.querySelector(`.bundle-add-btn[data-variant-id="${id}"]`);

        function renderBundle() {
            bar.classList.toggle('hidden', bundle.length === 0);

            /* slot thumbnails */
            slots.forEach((slot, i) => {
                const item = bundle[i];
                if (item) {
                    slot.innerHTML =
                        `<img src="${item.img}" alt="${item.title}"
                    class="w-full h-full object-cover rounded" />
               <button type="button"
                       class="bundle-remove absolute top-0 right-0 text-sm p-px">&times;</button>`;
                    slot.dataset.variantId = item.id;
                    slot.classList.remove('border-dashed', 'text-gray-400');
                    slot.classList.add('relative');
                } else {
                    slot.textContent = 'ADD';
                    delete slot.dataset.variantId;
                    slot.classList.add('border-dashed', 'text-gray-400');
                    slot.classList.remove('relative');
                }
            });

            /* running total */
            const subtotal = bundle.reduce((sum, itm) => sum + itm.price, 0);

            if (bundle.length < MAX_ITEMS) {
                totalEl.innerHTML = `Total ${formatMoney(subtotal)}`;
                progressEl.textContent =
                    `Add ${MAX_ITEMS - bundle.length} more to get the bundle at ${OFFER_PRICE_STRING}`;
            } else {
                totalEl.innerHTML =
                    `Total ${formatMoney(OFFER_PRICE_INT)} <s class="opacity-60 ml-1">${formatMoney(subtotal)}</s>`;
                progressEl.textContent = `Can't add more products`;
            }

            /* plus bubbles & CTA */
            plusIcons.forEach(p => {
                p.style.visibility = bundle.length === MAX_ITEMS ? 'hidden' : 'visible';
            });
            nextBtn.disabled = bundle.length !== MAX_ITEMS;
            nextBtn.textContent = bundle.length === MAX_ITEMS ? 'Add to cart' : 'Next';
        }

        /* card click */
        document.querySelectorAll('.bundle-add-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const id = btn.dataset.variantId;
                const price = parseInt(btn.dataset.productPrice, 10);
                if (!id || !price || bundle.length >= MAX_ITEMS) return;
                if (bundle.some(itm => itm.id === id)) return;

                bundle.push({
                    id, price,
                    title: btn.dataset.productTitle || '',
                    img: btn.dataset.productImg || ''
                });

                btn.classList.add('opacity-50', 'pointer-events-none');
                btn.innerHTML = BTN_DONE;
                renderBundle();
            });
        });

        /* remove */
        bar.addEventListener('click', e => {
            const removeBtn = e.target.closest('.bundle-remove');
            if (!removeBtn) return;

            const slot = removeBtn.closest('.bundle-slot');
            const id = slot && slot.dataset.variantId;
            if (!id) return;

            const cardBtn = cardBtnFor(id);
            if (cardBtn) {
                cardBtn.classList.remove('opacity-50', 'pointer-events-none');
                cardBtn.innerHTML = BTN_ADD;
            }

            const idx = bundle.findIndex(itm => itm.id === id);
            if (idx > -1) bundle.splice(idx, 1);
            renderBundle();
        });

        /* one /cart/add.js request */
        nextBtn.addEventListener('click', async () => {
            if (bundle.length !== MAX_ITEMS) return;
            nextBtn.disabled = true;
            try {
                const body = { items: bundle.map(itm => ({ id: itm.id, quantity: 1 })) };
                const res = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body)
                });
                if (!res.ok) throw new Error(res.status);
                bundle.length = 0;
                renderBundle();
            } catch (e) {
                console.error(e);
                alert('Sorry, something went wrong adding your bundle.');
            } finally {
                nextBtn.disabled = false;
            }
        });

        renderBundle();
    });
})();
